module.exports = __webpack_public_path__ + "static/media/error.070137fc.svg";